// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vy_a bhe_b bhe_wb"};